module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-ExtraBoldItalic.bb9e944.woff";